﻿import { api } from "./api.js";

export async function createAccount({ name, email, password }) {
  const r = await api("/auth/signup", { method: "POST", body: { name, email, password } });
  return { ...r.user, token: r.token };
}

export async function verifyLogin({ email, password }) {
  const r = await api("/auth/login", { method: "POST", body: { email, password } });
  return { ...r.user, token: r.token };
}

export async function signOut() {
  try { await api("/auth/logout", { method: "POST", auth: true }); } catch { /* already signed out */ }
}
